module.exports = __webpack_public_path__ + "static/media/ICAMP.5335637f.png";